import {DateTime} from 'luxon';

export const getUTCDateTime = (): DateTime<true> => DateTime.now().toUTC();

export const getUTCDateTimeFromString = (
  date: string | undefined
): DateTime<true> => {
  if (!date) {
    throw new Error('Date not provided!');
  }
  const dateTime = DateTime.fromISO(date);
  if (!dateTime.isValid) {
    throw new Error('Invalid date format!');
  }
  return dateTime.toUTC();
};

export const getUTCDateTimeFromMillis = (timestamp: number): DateTime<true> => {
  const dateTime = DateTime.fromMillis(timestamp);
  if (!dateTime.isValid) {
    throw new Error('Invalid date format!');
  }
  return dateTime.toUTC();
};
